import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { showSendConsultNowInvitationModal } from 'actions/modal';

const CenterPanelExpired = (props) => {
  const dispatch = useDispatch();
  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white mrlnull mrbnull mrtm mrrl';

  const backToLastPage = () => {
    props.setSendInvitationSuccessfully(false);
    props.setSendInvitationExpired(false);
  };

  return (
    <div className="ui form mrbl pdtsss">
      <div className="title-sms mrtm">
        <span className="bold waiting-area-red">0m:00s&nbsp;</span>
        <span>{APP.LANGUAGE.SendConsultNowInvitation.ExpiredMessage}</span>
      </div>
      <button tabIndex="1" type="button" className={saveClasses + ' no-icon-btn'} onClick={backToLastPage}>
        {APP.LANGUAGE.ViewOneWaitingArea.ConsultNow}
      </button>
      <button
        tabIndex="2"
        type="button"
        className="ui labeled icon button color-bad-things left-text color-bad-things-hover color-white mrlnull mrbnull mrtm"
        onClick={() => dispatch(showSendConsultNowInvitationModal(false))}
      >
        <i className="remove  icon" />
        {APP.LANGUAGE.Cancel}
      </button>
    </div>
  );
};

export default CenterPanelExpired;
